import { css } from '@emotion/core'
import styled from '@emotion/styled'

import { BorderRadius } from '../../enums/borderRadius'
import { Color } from '../../enums/color'
import { Spacing } from '../../enums/spacing'
import { getDefaultTransition } from '../../utils/getDefaultTransition'
import { getShadow } from '../../utils/getShadow'

const activeStyle = css`
  ${getShadow(undefined, { borderColor: Color.Lavender500, borderWidth: 2 })};
`

const clickableStyle = css`
  cursor: pointer;

  &:hover {
    ${getShadow(undefined, { borderColor: Color.Black, borderWidth: 2 })};
  }
`

const disabledStyle = css`
  opacity: 0.5;
  cursor: not-allowed;
`

interface AmountInfoBoxWrapperProps {
  active?: boolean
  badgeOnly?: boolean
  clickable?: boolean
  disabled?: boolean
}

export const AmountInfoBoxWrapper = styled.div<AmountInfoBoxWrapperProps>`
  ${({ badgeOnly }) =>
    badgeOnly
      ? css`
          min-height: 52px;
          padding: ${Spacing.S16} ${Spacing.S24} ${Spacing.S4};
        `
      : css`
          min-height: 116px;
          padding: ${Spacing.S16} ${Spacing.S24} ${Spacing.S24};
        `}
  border-radius: ${BorderRadius.R16};
  background-color: ${Color.White};

  ${getShadow(undefined, { borderColor: Color.Grey200, borderWidth: 1 })};
  ${getDefaultTransition('box-shadow', 'background')};

  ${({ active, disabled }) => active && !disabled && activeStyle};
  ${({ active, clickable, disabled }) => clickable && !active && !disabled && clickableStyle};
  ${({ disabled }) => disabled && disabledStyle}
`

export const BadgeWithLabelWrapper = styled.div`
  margin-bottom: ${Spacing.S12};
`
